import React from "react";
import { Link } from "react-router-dom";
import { Card } from "../../shared";
import {
  QuestionMarkCircleIcon,
  DocumentTextIcon,
  ChatBubbleLeftRightIcon,
  BugAntIcon,
} from "@heroicons/react/24/outline";
import { buildHelpFeaturesPath } from "@/features/help-hub/help-links";

const MainSections = () => {
  const mainSections = [
    {
      title: "Getting Started",
      description: "Learn the basics of using Attune and explore all features",
      icon: <DocumentTextIcon className="h-6 w-6" />,
      link: "/help/features",
      external: false,
    },
    {
      title: "FAQ",
      description: "View in-app troubleshooting and FAQs by module",
      icon: <QuestionMarkCircleIcon className="h-6 w-6" />,
      link: buildHelpFeaturesPath("feedback"),
      external: false,
    },
    {
      title: "Contact Support",
      description: "Get in touch with our support team",
      icon: <ChatBubbleLeftRightIcon className="h-6 w-6" />,
      link: "/feedback/create",
      external: false,
    },
    {
      title: "Report a Bug",
      description: "Found an issue? Let us know",
      icon: <BugAntIcon className="h-6 w-6" />,
      link: "/feedback/create",
      external: false,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
      {mainSections.map((section) => (
        <Link
          key={section.title}
          to={section.link}
          className="block"
        >
          <Card className="h-full p-6 hover:shadow-lg transition-shadow duration-200">
            <div className="flex flex-col items-center text-center">
              <div className="p-3 bg-primary-100 rounded-full mb-4">
                {section.icon}
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {section.title}
              </h3>
              <p className="text-gray-600">{section.description}</p>
            </div>
          </Card>
        </Link>
      ))}
    </div>
  );
};

export default MainSections;
